import { fillString } from '@local_modules/generic/string-template.js'
import { generateRandomString } from '@local_modules/generic/text/generate-random-string/index.js'
import { setElementHtml, showElement } from '../../../../helpers/generic-js/dom.js'
import { applyHtmlRestrictions } from '../../../../helpers/restrictions/apply-html-restrictions.js'
import { checkPageRestriction } from '../../../../helpers/restrictions/check-page-restriction.js'

import htmlTemplate from './index.html'
import { showEntityInfo } from './overall-entity-info.js'
import { showSyncManagement } from './sync-management/show-sync-management.js'
import { showDataCoverage } from './show-data-coverage.js'
import { showEntityRecordsCount } from './show-entity-records-count.js'
import { showJournalsIssues } from './data-issues/show-journals-issues.js'

/**
 *
 * @returns
 */
export async function showAdminEntity (params) {
  console.log('showAdminEntity')

  const { containerElementId, browserAppUser, accountingOrganisationId } = params

  if (!checkPageRestriction({ browserAppUser, allowNoAccount: true })) return

  // Prepare the html
  let htmlIndex = applyHtmlRestrictions(htmlTemplate, { browserAppUser })
  const elementId = 'i' + generateRandomString()
  htmlIndex = fillString(htmlIndex, {
    elementId,
    accountingOrganisationId
  })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  showEntityInfo(accountingOrganisationId)

  showElement('organisationSyncManagement')
  showSyncManagement(accountingOrganisationId)

  showJournalsIssues(accountingOrganisationId)
  showEntityRecordsCount(accountingOrganisationId)
  showDataCoverage(accountingOrganisationId)
}
